export default {
  $ne: (value, toCompare) => value !== toCompare,
  $eq: (value, toCompare) => value === toCompare
}
